export enum ImageResolutionName {
  Resolution_38x38 = 'resolution_38x38',
  Resolution_400x = 'resolution_400x'
}



// WEBPACK FOOTER //
// ./src/components/App/imageQueue/enum/imageResolutionName.ts